import React from "react";
import "../EmployeeTransfer/Board.css";
import List from "./List";

const Policy = () => {
    return (
        <div className="policy">
            <List />
        </div>
    );
};

export default Policy;
